import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';
import { Button as ButtonComponent, DialogComponent, ToggleButton } from '@themes/aegix';
import type { IncidentEventType } from '../../../services/alerts.service';

const FILTER_KEYS: IncidentEventType[] = [
  'incident',
  'chat',
  'report',
  'notify',
  'map',
];
const DEFAULT_SELECTION: Record<IncidentEventType, boolean> = {
  incident: true,
  chat: true,
  report: true,
  notify: false,
  map: false,
};

interface AlertHistoryFilterDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (incidentTypesCsv: string) => void;
  initialSelection?: Record<IncidentEventType, boolean>;
}

export function AlertHistoryFilterDialog({
  isOpen,
  onClose,
  onApply,
  initialSelection,
}: AlertHistoryFilterDialogProps) {
  const { t } = useTranslation();
  const [selection, setSelection] = useState<
    Record<IncidentEventType, boolean>
  >(initialSelection ?? DEFAULT_SELECTION);

  const handleToggle = (key: IncidentEventType, checked: boolean) => {
    setSelection((prev) => ({ ...prev, [key]: checked }));
  };

  const handleApply = () => {
    const csv = FILTER_KEYS.filter((key) => selection[key]).join(',');
    onApply(csv);
    onClose();
  };

  return (
    <DialogComponent
      isOpen={isOpen}
      onClose={onClose}
      e2eTitle="alertHistoryFilterDialog"
      headingText={t('events.filterEvents', 'Filter Events')}
      size="md"
    >
      <Flex p={4} pt={1} gap={4} direction="column">
        {FILTER_KEYS.map((key) => (
          <ToggleButton
            key={key}
            title={key.charAt(0).toUpperCase() + key.slice(1)}
            e2eTitle={key}
            name={key}
            checked={selection[key]}
            onCheckedChange={(e: { checked: boolean }) =>
              handleToggle(key, e.checked)
            }
          />
        ))}
        <ButtonComponent visual="primary" onClick={handleApply}>
          {t('common.apply', 'Apply')}
        </ButtonComponent>
      </Flex>
    </DialogComponent>
  );
}
